/** @jsx jsx */
import { useState } from 'react';
import { jsx } from 'theme-ui';
import { ChevronDown, ChevronUp } from '../Icons';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var getDefaultValue = function getDefaultValue(_ref) {
  var defaultValue = _ref.defaultValue,
      type = _ref.type,
      flowType = _ref.flowType;
  var propType = flowType ? flowType : type;
  if (!defaultValue || !defaultValue.value) return null;

  if (defaultValue.value === "''") {
    return '[Empty string]';
  }

  if (propType && propType.name === 'string') {
    return defaultValue.value.replace(/\'/g, '"');
  }

  if (typeof defaultValue.value === 'object' && defaultValue.value.toString) {
    return defaultValue.value.toString();
  }

  return defaultValue.value;
};

if (typeof getDefaultValue !== 'undefined' && getDefaultValue && getDefaultValue === Object(getDefaultValue) && Object.isExtensible(getDefaultValue) && !getDefaultValue.hasOwnProperty('__filemeta')) {
  Object.defineProperty(getDefaultValue, '__filemeta', {
    configurable: true,
    value: {
      name: "getDefaultValue",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/index.js"
    }
  });
}

export var Prop = function Prop(_ref2) {
  var propName = _ref2.propName,
      prop = _ref2.prop,
      getPropType = _ref2.getPropType,
      isToggle = _ref2.isToggle;

  var _useState = useState(isToggle || false),
      showing = _useState[0],
      setShowing = _useState[1];

  if (!prop.type && !prop.flowType) return null;

  var toggle = function toggle() {
    return setShowing(function (s) {
      return !s;
    });
  };

  return jsx("div", {
    sx: styles.line,
    "data-testid": "prop"
  }, jsx("div", {
    sx: styles.content
  }, jsx("div", {
    sx: styles.propName,
    "data-testid": "prop-name"
  }, propName), jsx("div", {
    sx: styles.propType,
    "data-testid": "prop-type"
  }, getPropType(prop)), prop.defaultValue && jsx("div", {
    sx: styles.defaultValue,
    "data-testid": "prop-default-value"
  }, jsx("em", null, getDefaultValue(prop))), jsx("div", {
    sx: styles.right
  }, prop.required && jsx("div", {
    sx: styles.propRequired,
    "data-testid": "prop-required"
  }, jsx("strong", null, "required")), prop.description && jsx("button", {
    sx: styles.openDescBtn,
    onClick: toggle,
    "data-testid": "prop-toggle-description"
  }, showing ? jsx(ChevronUp, {
    size: 20
  }) : jsx(ChevronDown, {
    size: 20
  })))), showing && prop.description && jsx("div", {
    sx: styles.description,
    "data-testid": "prop-description"
  }, prop.description));
};

if (typeof Prop !== 'undefined' && Prop && Prop === Object(Prop) && Object.isExtensible(Prop) && !Prop.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Prop, '__filemeta', {
    configurable: true,
    value: {
      name: "Prop",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/index.js"
    }
  });
}

export var Props = function Props(_ref3) {
  var props = _ref3.props,
      getPropType = _ref3.getPropType,
      isToggle = _ref3.isToggle;
  var entries = Object.entries(props);
  return jsx("div", {
    sx: styles.container,
    "data-testid": "props"
  }, entries.map(function (_ref4) {
    var key = _ref4[0],
        prop = _ref4[1];
    return jsx(Prop, {
      key: key,
      propName: key,
      prop: prop,
      getPropType: getPropType,
      isToggle: isToggle
    });
  }));
};

if (typeof Props !== 'undefined' && Props && Props === Object(Props) && Object.isExtensible(Props) && !Props.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Props, '__filemeta', {
    configurable: true,
    value: {
      name: "Props",
      filename: "node_modules/gatsby-theme-docz/src/components/Props/index.js"
    }
  });
}